const listener = (event) => {
  event.preventDefault();
  event.returnValue = '';
};
export const enablePrevent = () => window.addEventListener('beforeunload', listener);
export const disablePrevent = () => window.removeEventListener('beforeunload', listener);
